import React from 'react';

import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

import Typography from '@ts-core/components/Typography';

export interface SubjectItemGridCardProps<TItem extends object> {
  loading?: boolean;
  item?: TItem;
  getName?: (item?: TItem) => React.ReactNode;
  getBackgroundImage?: (item?: TItem) => string;

  onClick: React.EventHandler<any>;
}

const SubjectItemGridCard = <TItem extends object>(props: SubjectItemGridCardProps<TItem>) => {
  const { item, getName, getBackgroundImage, loading, onClick } = props;

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      borderRadius="8px"
      boxShadow={loading ? 0 : 1}
      overflow="hidden"
      position="relative"
      color="white"
      sx={(theme) => ({
        transition: theme.transitions.create('box-shadow', {
          duration: theme.transitions.duration.standard,
        }),
        '&:hover': {
          boxShadow: loading ? undefined : theme.shadows[3],
        },
      })}
    >
      <ButtonBase
        disabled={loading}
        component="div"
        onClick={onClick}
        disableRipple
        sx={(theme) => ({
          position: 'relative',
          minHeight: 70,
          flexGrow: 1,
          paddingTop: getBackgroundImage && item ? '56.25%' : undefined,
          backgroundColor: loading ? theme.palette.grey[200] : theme.palette.secondary.main,
          backgroundImage: !loading && getBackgroundImage && item ? `url(${getBackgroundImage?.(item)})` : undefined,
        })}
      >
        <Box
          position="absolute"
          pl={2}
          pr={4}
          py={1}
          color="white"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          bottom={0}
          left={0}
          right={0}
        >
          <Typography variant="subtitle2" color="inherit" loading={loading} skeletonWidth="30%" sx={{ textShadow: '1px 1px rgba(1, 0, 0, 0.3)' }}>
            {getName?.(item)}
          </Typography>
        </Box>
      </ButtonBase>
    </Box>
  );
};

export default SubjectItemGridCard;
